import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { MaskedLine, Reveal } from "@/components/Reveal";
import { BRAND } from "@/data/content";

export default function FinalCTA() {
    return (
        <section className="relative overflow-hidden" data-testid="final-cta">
            <div className="absolute inset-0">
                <img src="/assets/img/ecosystem.jpg" alt="" aria-hidden="true" className="h-full w-full object-cover opacity-30" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-b from-void via-black/60 to-black" />
            </div>
            <div className="relative z-10 mx-auto flex min-h-[110vh] max-w-[1400px] flex-col items-center justify-center px-5 py-32 text-center md:px-10">
                <MaskedLine delay={0.1}>
                    <span className="font-mono text-xs uppercase tracking-[0.45em] text-white/50">
                        Your business is already online.
                    </span>
                </MaskedLine>
                <MaskedLine delay={0.6}>
                    <span className="mt-6 block font-mono text-xs uppercase tracking-[0.45em] text-white/50">
                        The question is…
                    </span>
                </MaskedLine>
                <h2 className="mt-10 font-display font-black tracking-tighter" data-testid="final-headline">
                    <MaskedLine delay={1.1}>
                        <span className="block text-5xl leading-[0.95] text-white sm:text-6xl lg:text-8xl">IS IT WORKING</span>
                    </MaskedLine>
                    <MaskedLine delay={1.35}>
                        <span className="block text-5xl leading-[0.95] text-white sm:text-6xl lg:text-8xl">HARD ENOUGH?</span>
                    </MaskedLine>
                </h2>
                <Reveal delay={2.0}>
                    <p className="mt-14 font-display text-3xl font-black tracking-[0.25em] text-white sm:text-4xl">HIGHTS</p>
                    <p className="mt-3 text-sm font-light uppercase tracking-[0.3em] text-white/55">
                        Your business. Engineered to grow.
                    </p>
                </Reveal>
                <Reveal delay={2.3}>
                    <div className="mt-12 flex w-full max-w-md flex-col gap-3 sm:max-w-none sm:flex-row sm:gap-4">
                        <Link
                            to="/book"
                            data-testid="final-book-button"
                            className="bg-white px-9 py-4 text-center text-xs font-bold uppercase tracking-[0.25em] text-black transition-colors duration-300 hover:bg-white/80"
                        >
                            Book a free 10–20 min consultation
                        </Link>
                        <button
                            onClick={() => document.getElementById("demos")?.scrollIntoView({ behavior: "smooth" })}
                            data-testid="final-demos-button"
                            className="border border-white/25 px-9 py-4 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white/10"
                        >
                            Experience the demos
                        </button>
                        <motion.a
                            href={`https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(BRAND.whatsappMsg)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="final-whatsapp-button"
                            className="flex items-center justify-center gap-2.5 border border-white/25 px-9 py-4 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white/10"
                            whileHover={{ scale: 1.02 }}
                        >
                            <WhatsappLogo size={16} weight="fill" /> WhatsApp HIGHTS
                        </motion.a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
